export default __webpack_public_path__ + "static/media/Ua.1684b729.png";